
    import './styles.scoped.css';
    export default {
  "layout": "awsui_layout_5gtk3_12weq_9",
  "background": "awsui_background_5gtk3_12weq_23",
  "is-overlap-disabled": "awsui_is-overlap-disabled_5gtk3_12weq_28",
  "header-background": "awsui_header-background_5gtk3_12weq_31",
  "notifications": "awsui_notifications_5gtk3_12weq_35",
  "breadcrumbs": "awsui_breadcrumbs_5gtk3_12weq_40",
  "default-padding": "awsui_default-padding_5gtk3_12weq_45",
  "header-wrapper": "awsui_header-wrapper_5gtk3_12weq_49",
  "with-divider": "awsui_with-divider_5gtk3_12weq_54",
  "content": "awsui_content_5gtk3_12weq_57",
  "has-header": "awsui_has-header_5gtk3_12weq_61",
  "is-visual-refresh": "awsui_is-visual-refresh_5gtk3_12weq_68",
  "has-default-background": "awsui_has-default-background_5gtk3_12weq_68",
  "has-notifications": "awsui_has-notifications_5gtk3_12weq_72"
};
  